import React from 'react'
import { Row, Col, FormGroup, Label, Input } from 'twyne-new.ui';

const NitroForm = ({data, onChange, disabled}) => {
  return (
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Affiliate ID</Label>
            <Input type="text" value={data.aff_id || ''}
              onChange={(e) => onChange('aff_id', e.target.value)} disabled={disabled}
              />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <Label>SID</Label>
            <Input type="text" value={data.sid || ''}
              onChange={(e) => onChange('sid', e.target.value)} disabled={disabled}
              />
        </FormGroup>
      </Col>
    </Row>
    
  );
}

export default NitroForm;